export default __webpack_public_path__ + "static/media/AboutesCRE.e6fd7d5f.svg";